"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _NavbarCss = _interopRequireDefault(require("./Navbar.css.js"));

var _useScrollTrigger = _interopRequireDefault(require("@material-ui/core/useScrollTrigger"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ElevationScroll = function ElevationScroll(props) {
  var children = props.children;
  var trigger = (0, _useScrollTrigger.default)({
    disableHysteresis: true,
    threshold: 0,
    target: window
  });
  return (0, _react.cloneElement)(children, {
    elevation: trigger ? 4 : 0
  });
};

var Navbar = function Navbar(_ref) {
  var drawerClick = _ref.drawerClick,
      goHome = _ref.goHome,
      brand = _ref.brand,
      styleVariant = _ref.styleVariant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["drawerClick", "goHome", "brand", "styleVariant", "children"]);

  var fullNavStyle = Object.assign({}, _NavbarCss.default.navbar, styleVariant.navbar);
  var fullToolStyle = Object.assign({}, _NavbarCss.default.toolbar, styleVariant.toolbar);
  var fullNavContentStyle = Object.assign({}, _NavbarCss.default.navContent, styleVariant.navContent);
  var fullBrandStyle = Object.assign({}, _NavbarCss.default.brand, styleVariant.brand);
  var fullMenuStyle = Object.assign({}, _NavbarCss.default.menuIcon, styleVariant.menuIcon);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ElevationScroll, props, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "fixed",
    key: "navbar_key",
    style: fullNavStyle
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    style: fullToolStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "brand_key",
    style: fullNavContentStyle
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: brand,
    alt: "bluekeel_brand",
    onClick: goHome,
    style: fullBrandStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    key: "icon_key",
    style: fullMenuStyle,
    onClick: drawerClick
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fal', 'bars'],
    fixedWidth: true
  })))))), /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    style: {
      minHeight: '50px',
      height: '60px'
    }
  }), children);
};

var _default = (0, _radium.default)(Navbar);

exports.default = _default;

//# sourceMappingURL=Navbar.jsx.map